import { Controller } from "@hotwired/stimulus"

// PΔ.301.1 — форма входа диагностики: отправляет ссылку в API и уводит на страницу отчёта.
// Страница отчёта сама показывает прогресс (diagnostic-progress). Никакой логики
// разбора ссылки здесь нет — она одна, на сервере (UrlExtractor).
export default class extends Controller {
  static targets = ["input", "button", "error"]
  static values = { endpoint: String, locale: String, utm: String, autostart: Boolean }

  // 24.09.2026: запуск по ссылке /?url=… (ИИ-ассистенты отдают человеку готовую ссылку).
  // Стартуем только в настоящем браузере: краулеры и превью ссылок JS не исполняют,
  // а headless-агентов отсекаем по navigator.webdriver. Лимит по IP на сервере остаётся.
  connect() {
    if (!this.autostartValue) return
    if (!this.hasInputTarget || !this.inputTarget.value.trim()) return
    if (navigator.webdriver) return
    if (/bot|crawl|spider|slurp|preview|fetch|headless/i.test(navigator.userAgent)) return
    this.submit()
  }

  async submit(event) {
    if (event) event.preventDefault()
    const url = this.inputTarget.value.trim()
    if (!url) return

    this.setBusy(true)
    this.showError("")

    let utm = {}
    try { utm = JSON.parse(this.utmValue || "{}") } catch (_) { utm = {} }

    try {
      const resp = await fetch(this.endpointValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || ""
        },
        body: JSON.stringify({ url, locale: this.localeValue, ...utm })
      })
      const data = await resp.json().catch(() => ({}))
      if (!resp.ok) {
        this.showError(this.messageFor(data.error || "generic"))
        this.setBusy(false)
        return
      }
      window.location.assign(this.localReportPath(data))
    } catch (_) {
      this.showError(this.messageFor("network"))
      this.setBusy(false)
    }
  }

  // report_url в ответе — публичный адрес; на локальном/стенде идём по относительному пути.
  localReportPath(data) {
    const path = `/report/${data.id}`
    const locale = this.localeValue && this.localeValue !== "en" ? `?locale=${this.localeValue}` : ""
    return path + locale
  }

  setBusy(busy) {
    this.buttonTarget.disabled = busy
    this.inputTarget.readOnly = busy
    this.buttonTarget.dataset.label ||= this.buttonTarget.textContent
    this.buttonTarget.textContent = busy ? "…" : this.buttonTarget.dataset.label
  }

  showError(text) {
    this.errorTarget.textContent = text
    this.errorTarget.classList.toggle("hidden", !text)
  }

  messageFor(code) {
    const el = document.querySelector(`[data-diagnostic-error="${code}"]`) ||
               document.querySelector('[data-diagnostic-error="generic"]')
    return el ? el.textContent : code
  }
}
